// ANCHOR React
import React from 'react';

// ANCHOR Base
import { Block, BlockOverrides } from 'baseui/block';
import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import { PopoverOverrides } from 'baseui/popover';

// ANCHOR Styles
import { BLOCK } from './styles';

export interface ITooltipDisabledButtonOverrides {
  tooltip?: PopoverOverrides;
  block?: BlockOverrides;
}

interface IProps {
  isDisabled?: boolean;
  content?: string;
  children: React.ReactNode;
  endEnhancer?: React.ReactNode;
  overrides?: ITooltipDisabledButtonOverrides;
}

export function TooltipDisabledButton({
  content,
  children,
  isDisabled,
  endEnhancer,
  overrides,
}: IProps) {
  if (isDisabled) {
    return (
      <StatefulTooltip
        accessibilityType="tooltip"
        content={content}
        placement={PLACEMENT.bottom}
        overrides={overrides?.tooltip}
        showArrow
        returnFocus
        renderAll
      >
        <Block overrides={overrides?.block ?? BLOCK}>
          {children}
        </Block>
      </StatefulTooltip>
    );
  }

  return (
    <>
      {children}
      {endEnhancer}
    </>
  );
}
